<div class="wrapper">
  <router-outlet></router-outlet>
</div>

<div
  id="quick-measure"
  class="absolute bottom-0"></div>
